import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  menuTree: [],
  permissions: [],
  role: null,
  loaded: false,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setMenuData: (state, action) => {
      state.menuTree = action.payload.menuTree || [];
      state.permissions = action.payload.permissions || [];
      state.role = action.payload.role || null;
      state.loaded = true;
    },
    clearMenuData: (state) => {
      state.menuTree = [];
      state.permissions = [];
      state.role = null;
      state.loaded = false;
    },
  },
});

export const { setMenuData, clearMenuData } = menuSlice.actions;
export default menuSlice.reducer;
